// @ts-nocheck
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrderForApproval";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const SetApprover = createChainHandler("SetApprover", chain, props => {
    const { approverId } = props.parameter as { approverId?: string };

    if (approverId) {
        props.apiParameter.cart.properties = {
            ...props.apiParameter.cart.properties,
            approverId,
        };
    }
});

addToChainAfter(chain, PopulateApiParameter, SetApprover);
